import { render, staticRenderFns } from "./GlossaryEntryName.vue?vue&type=template&id=1fb50827"
import script from "./GlossaryEntryName.vue?vue&type=script&lang=js"
export * from "./GlossaryEntryName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports